/**
 * Ссылка на карточку товара с выбранным вариантом.
 *
 * Каждая карточка каталога — один вариант товара (Айталы 02.10: «каждая
 * карточка — один вариант товара»), и страница товара открывается ровно на
 * нём: читает `?variant=<variantId>` и показывает его фото, цену и размеры.
 * Плитки вариантов на странице меняют тот же параметр.
 */
export const VARIANT_PARAM = "variant";

export const productHref = (productId: string, variantId?: string | null): string => {
	const base = `/product/${encodeURIComponent(productId)}`;
	return variantId ? `${base}?${VARIANT_PARAM}=${encodeURIComponent(variantId)}` : base;
};
